<template>
  <div>
    <simple-query-builder-group
      ref="group"
      :types="types"
      :operators="operators"
      :operands="operands"
      :depth="1"
      :query="query"
      :max-depth="maxDepth"
      @add-group="handleAddGroup"
      @remove-group="handleRemoveGroup"
      @add-rule="handleAddRule"
      @remove-rule="handleRemoveRule"
      @change-operand="handleChangeOperand"
      @change-operator="handleChangeOperator"
      @change-value="handleChangeValue"
      @enter-keyup="handleEnterKeyUp"
    />
    <v-btn
      color="primary"
      small
      @click="handleClickClear"
    >
      <span>{{ clearText }}</span>
    </v-btn>
    <v-btn
      color="primary"
      small
      @click="handleClickReset"
    >
      <span>{{ resetText }}</span>
    </v-btn>
  </div>
</template>

<script>
import SimpleQueryBuilderGroup from './SimpleQueryBuilderGroup'

function dupQuery (q) {
  return JSON.parse(JSON.stringify(q))
}
export default {
  components: {
    SimpleQueryBuilderGroup
  },

  props: {
    types: {
      type: Array,
      required: true
    },
    operators: {
      type: Array,
      required: true
    },
    operands: {
      type: Array,
      required: true
    },
    _limits: {
      type: Array,
      default () {
        return [5, 10, 25, 50, 100]
      }
    },
    _query: {
      type: Object,
      default () {
        return {
          operator: 'ALL',
          children: []
        }
      }
    },
    maxDepth: {
      type: Number,
      default: 3
    },
    periodLabel: {
      type: String,
      default: 'periodLabel'
    },
    searchText: {
      type: String,
      default: 'Get Query '
    },
    clearText: {
      type: String,
      default: 'Clear'
    },
    resetText: {
      type: String,
      default: 'Reset'
    }
  },

  data () {
    return {
      startMenu: false,
      endMenu: false,
      limits: this._limits,
      query: dupQuery(this._query)
    }
  },

  watch: {
    _query: {
      handler () {
        this.query = dupQuery(this.query)
      },
      deep: true
    }
  },

  methods: {
    handleClickSearch () {
      this.$emit('search', dupQuery(this.query), true)
    },

    handleClickClear () {
      const query = dupQuery({
        operator: 'ALL',
        children: [
          {
            type: 'rule',
            query: {
              operator: '',
              operand: '',
              value: ''
            }
          }
        ]
      })
      this.query = query
      this.$emit('clear', query)
    },

    handleClickReset () {
      const query = dupQuery(this.query)
      this.query = query
      this.$emit('clear', query)
    },

    handleEnterKeyUp () {
      this.handleClickSearch()
    },

    handleAddGroup () {
      this.$emit('add-group', ...arguments)
    },

    handleRemoveGroup () {
      this.$emit('remove-group', ...arguments)
    },

    handleAddRule () {
      this.$emit('add-rule', ...arguments)
    },

    handleRemoveRule () {
      this.$emit('remove-rule', ...arguments)
    },

    handleChangeOperand () {
      this.$emit('change-operand', ...arguments)
    },

    handleChangeOperator () {
      this.$emit('change-operator', ...arguments)
    },

    handleChangeValue () {
      this.$emit('change-value', ...arguments)
    }
  }
}
</script>
